import engagementSvg from "../assets/generated/engagement.svg?raw";

export function EngagementMapVisual() {
  return (
    <figure className="graph-figure">
      <div
        className="graph-figure-frame"
        dangerouslySetInnerHTML={{ __html: engagementSvg }}
      />
      <figcaption className="graph-figure-caption">
        Most jobs use more than one of these at once.
      </figcaption>
    </figure>
  );
}
